import HeartIcon from "assets/icons/heart.svg";
import CheckmarkIcon from "assets/icons/checkmark.svg";
import ListIcon from "assets/icons/list.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVirus } from "@fortawesome/free-solid-svg-icons";
import { Trans } from "react-i18next";
import Modal from "react-modal";
import {checkAndGetSessionStorageValue} from "../../../features/utils";
import i18next from "i18next";
import { careOptions } from "../../../server/triage/constants";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};
var careoptionslist = [];
var incrementvalue = 0;
const ListGroupHeader = ({ direction, allValues }) =>
  !direction ? null : (
    <div className="care-option-result-type-group-header">
      <div
        className={`care-option-result-type care-option-result-type--${direction.toLowerCase()}`}
        >
        <div className="inline mr-1 icon">
          {direction === "Top" ? (
            <HeartIcon />
          ) : direction === "Good" ? (
            <CheckmarkIcon />
          ) : (
            <ListIcon />
          )}
        </div>
        {direction === "Other" ? (
          <Trans i18nKey="findcareoption.Careoptions.More_options">
            'More Options'
          </Trans>
        ) : direction === "Top" ? (
          <Trans i18nKey="findcareoption.Careoptions.Top">'Top'</Trans>
        ) : (
          <Trans i18nKey="findcareoption.Careoptions.Good">'Good'</Trans>
        )}
      </div>
      {/* {allValues.map((card, cardIndex) => (
        <div style={{display: "contents"}} >
        {card.isCovidTestingAvailable?
            <div
              className={`care-option-result-type care-option-result-type-covid`}
              >
              <div className="inline mr-1 icon">
              <FontAwesomeIcon style={{ color: "navy"}} icon={faVirus} />
              </div>
              <Trans i18nKey="findcareoption.Careoptions.COVIDTestingAvailable">
              COVID Testing Available
              </Trans>
            </div>
          :''
        }
        </div>
      ))}       */}
    </div>
  );

const Item = ({
  src,
  srcThumb,
  cashLess,
  alt,
  altText,
  value,
  text,
  linkText,
  bgColor,
  direction,
  goCareOption,
  selectCareOption,
  isCovidTestingAvailable,
  updateCoordination
}) => (
  <div className="care-option">
    <div className="care-option-inner care-optionsForMobile">
      <div className="care-option-image-container">
        <div className="care-option-image-inner">
          <img src={srcThumb} alt={alt} />
        </div>
      </div>
      <div className="care-option-content">
        <div className="care-option-title">
          {altText}
          {!cashLess ? null : (
            <span className="care-option-badge-blue">
              <Trans i18nKey="findcareoption.Careoptions.Cashless">
                Cashless
              </Trans>
            </span>
          )}
          {!isCovidTestingAvailable ? null : (
            <span className="care-option-badge-blue">
              <Trans i18nKey="findcareoption.Careoptions.COVIDTestingAvailable">
              COVID Testing Available
              </Trans>
            </span>
          )}
        </div>
        <p className="care-option-text">{text}</p>
        <a
          href="#"
          className="text-caps text-small"
          onClick={() => {
            selectCareOption({ alt, value });
            goCareOption({ alt, value });
          }}
          onKeyDown={(e) =>{
            if(e.key === " " || e.key ==="Spacebar"){
              selectCareOption({ alt, value });
              goCareOption({ alt, value })
            }
          }}
        >
          {linkText}
        </a>
      </div>
    </div>
  </div>
);

export default ({
  state,
  setState,
  history,
  cards,
  goCareOption,
  selectCareOption,
  updateCoordination,
  selectDeclineCareOption
}) => {
  const groupKeys = ["Top", "Good", "Other"];
  const groups = {};
  for (const card of cards) {
    const { direction } = card;
    if (direction == "Top" || direction == "Good" || direction == "Other") {      
      careoptionslist.push(card.alt);
    }
    if (!groups[direction]) groups[direction] = [];
    if (checkAndGetSessionStorageValue("IsValidUser") === "true") {
    if(card.alt !== "House Visit" && card.alt !=="Concierge Care"){
      groups[direction].push(card);
    }
  }
    else {
      groups[direction].push(card);
    }
  }

  return (
    <div className="care-options-list">    
      {groupKeys.map((key) =>
        !groups[key] || !groups[key].length ? null : (
          <div key={`care-options-group-${key}`}>
          <ListGroupHeader direction={key} allValues={groups[key]} />
            {groups[key].map((card, cardIndex) => (
              <Item
                key={`care-option-group-${key}-${cardIndex}`}
                {...card}
                goCareOption={goCareOption}
                selectCareOption={selectCareOption}
              />
            ))
            }

          </div>
        )
      )}
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          paddingTop: "20px",
          paddingBottom: "15px"
        }}
      >
        <a
          className="view-mode-toggle"
          onClick={(e) => {
            localStorage.setItem("careoption", "");
            setState({
              showModal1: true,
            });
          }}
          href='#'
          onKeyDown={(e)=>{
            if(e.key === " "|| e.key === "Spacebar"){
              localStorage.setItem("careoption","")
                  setState({
                    showModal1: true
                  })
            }
          }}
        >
          {
            <Trans i18nKey="findcareoption.Careoptions.Decline_care">
              Decline Care
            </Trans>
          }
        </a>
      </div>
      {!state.showModal && (<Modal
        isOpen={state.showModal1}
        contentLabel="customStyles"
        className="ReactModal__Content_triagepopup"
        overlayClassName="ReactModal__Overlay_triagepopup"
        role=""
      >
        <label className="confirm_title">
          {
            <Trans i18nKey="findcareoption.Careoptions.Please_confirm">
              Please confirm
            </Trans>
          }
        </label>
        <label>
          {
            <Trans i18nKey="findcareoption.Careoptions.Confirm_care">
              Are you sure you wish to decline your suggested care options and
              cancel the triage
            </Trans>
          }
        </label>
        <div className="pop_button">
          <button
            className="modal_yes"
            onClick={(e) => {
              setState({
                showModal1: false,
              });
              state.triageRequest.selectedCareOptionName = careOptions.DeclineCare;
              localStorage.setItem('careoption', careOptions.DeclineCare);
              selectDeclineCareOption();
              updateCoordination();
              // var data = updateTriageLogCoordination(state);
              // console.log(data)
              // actions.sendTriageRequest({
              //   action: "UpdateTriageCoordination",
              //   data: ({...data}),
              // });
              //actions.UpdateTriageCoordination({...data});
              history.push("/find-care-options/done");
            }}
            aria-label= {i18next.t("findcareoption.Careoptions.Confirm_care")+ " " +i18next.t("findcareoption.Yes")}
          >
            <Trans i18nKey="findcareoption.Yes">Yes</Trans>
          </button>
          <button
            className="modal_no"
            onClick={(e) => {
              setState({
                showModal1: false,
              });
            }}
            aria-label= {i18next.t("findcareoption.Careoptions.Confirm_care") + " " + i18next.t("findcareoption.No")}
          >
            <Trans i18nKey="findcareoption.No">No</Trans>
          </button>
        </div>
      </Modal>)}
    </div>
  );
};
